import { createClient } from "@sanity/client";

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID;
const dataset = process.env.REACT_APP_SANITY_DATASET || "production";
const previewToken = process.env.REACT_APP_SANITY_PREVIEW_TOKEN;

export const previewClient = projectId
  ? createClient({
      projectId,
      dataset,
      apiVersion: "2024-01-01",
      useCdn: false,
      token: previewToken,
      perspective: "previewDrafts",
      stega: {
        enabled: true,
        studioUrl: "http://localhost:3333",
      },
    })
  : null;
